import React from "react";

export default function HunterSuggestion({
  suggestion,
  onRefresh,
  onApply,
  onClose,
  kickerLabel = "✠ Sugestão do Caçador",
  refreshLabel = "Outra sugestao",
  applyLabel = "Usar sugestao",
  closeLabel = "Fechar",
}) {
  if (!suggestion) return null;

  return (
    <div className="hunter-suggestion-card" role="note" aria-live="polite">
      <div className="mini-guide-header">
        <div className="hunter-suggestion-kicker">{kickerLabel}</div>
        {typeof onClose === "function" ? (
          <button
            type="button"
            className="mini-guide-close"
            onClick={onClose}
            aria-label={closeLabel}
            title={closeLabel}
          >
            ×
          </button>
        ) : null}
      </div>
      <div className="hunter-suggestion-text">{suggestion}</div>
      {typeof onApply === "function" || typeof onRefresh === "function" ? (
        <div className="hunter-suggestion-actions">
          {typeof onApply === "function" ? (
            <button
              type="button"
              className="hunter-suggestion-apply"
              onClick={onApply}
            >
              {applyLabel}
            </button>
          ) : null}
          {typeof onRefresh === "function" ? (
            <button
              type="button"
              className="hunter-suggestion-refresh"
              onClick={onRefresh}
            >
              {refreshLabel}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
